module.exports = __webpack_public_path__ + "assets/download.cbe87bd1.svg";